<template>
  <div class="loading-mask"></div>
</template>

<script>
export default {
  name: 'loading',
}
</script>

<style scroped>
.loading-mask {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: hsla(0, 0%, 100%, 0.8);
}

.loading-mask .el-loading-spinner {
  display: none;
}
.loading-mask:after,
.loading-mask:before {
  position: absolute;
  content: '';
  width: 13px;
  height: 13px;
  top: 50%;
  left: 50%;
  margin: -7px 0 0 -7px;
  border-radius: 99%;
  border-radius: 999px;
  z-index: 1000;
  transition: opacity 0.15s, visibility 0s 0.15s;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.loading-mask:after {
  background: #f33b97;
  -webkit-transform: translateX(-20px);
  -ms-transform: translateX(-20px);
  transform: translateX(-20px);
  -webkit-animation: loading-mask_moveRight 0.4s linear infinite alternate;
  animation: loading-mask_moveRight 0.4s linear infinite alternate;
}

.loading-mask:before {
  background: #0080cc;
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
  -webkit-animation: loading-mask_moveLeft 0.4s linear infinite alternate;
  animation: loading-mask_moveLeft 0.4s linear infinite alternate;
}

@-webkit-keyframes loading-mask_moveRight {
  to {
    -webkit-transform: translateX(20px);
  }
}

@keyframes loading-mask_moveRight {
  to {
    -webkit-transform: translateX(20px);
    transform: translateX(20px);
  }
}

@-webkit-keyframes loading-mask_moveLeft {
  to {
    -webkit-transform: translateX(-20px);
  }
}

@keyframes loading-mask_moveLeft {
  to {
    -webkit-transform: translateX(-20px);
    transform: translateX(-20px);
  }
}
</style>
